// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100vh;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  padding: 20px;
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Custom styles for stock portfolio app */
.portfolio-card {
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.portfolio-card:hover {
  transform: translateY(-2px);
}

.stat-card {
  text-align: center;
  padding: 16px;
}

.price-positive {
  color: #4caf50;
}

.price-negative {
  color: #f44336;
}

.chart-container {
  height: 400px;
  margin: 16px 0;
}

.notification-item {
  border-left: 4px solid;
  padding-left: 12px;
}

.notification-item.unread {
  background-color: rgba(25, 118, 210, 0.08);
}

.dropzone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.dropzone:hover {
  border-color: #1976d2;
}

.dropzone.active {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C","sourcesContent":[".App {\n  text-align: center;\n  min-height: 100vh;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  padding: 20px;\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Custom styles for stock portfolio app */\n.portfolio-card {\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out;\n}\n\n.portfolio-card:hover {\n  transform: translateY(-2px);\n}\n\n.stat-card {\n  text-align: center;\n  padding: 16px;\n}\n\n.price-positive {\n  color: #4caf50;\n}\n\n.price-negative {\n  color: #f44336;\n}\n\n.chart-container {\n  height: 400px;\n  margin: 16px 0;\n}\n\n.notification-item {\n  border-left: 4px solid;\n  padding-left: 12px;\n}\n\n.notification-item.unread {\n  background-color: rgba(25, 118, 210, 0.08);\n}\n\n.dropzone {\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  padding: 20px;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.dropzone:hover {\n  border-color: #1976d2;\n}\n\n.dropzone.active {\n  border-color: #1976d2;\n  background-color: rgba(25, 118, 210, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
